import { render, staticRenderFns } from "./pie2.vue?vue&type=template&id=02d6122e&scoped=true&"
import script from "./pie2.vue?vue&type=script&lang=js&"
export * from "./pie2.vue?vue&type=script&lang=js&"
import style0 from "./pie2.vue?vue&type=style&index=0&id=02d6122e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d6122e",
  null
  
)

export default component.exports